export { default } from "./TypographyConfig";
